import { Platform } from 'react-native';
var DEFAULT_STATUSBAR_HEIGHT_EXPO = 0;
export var APPROX_STATUSBAR_HEIGHT = Platform.select({
  android: DEFAULT_STATUSBAR_HEIGHT_EXPO,
  ios: Platform.Version < 11 ? DEFAULT_STATUSBAR_HEIGHT_EXPO : 0
});